import React from "react";
import Link from "next/link";
import * as S from "./ArticleOnListTeaser.sc";
import {
  replaceDomainToTap,
  getRelativeArticlePath,
  getRelativeArticleServicesPath,
} from "../../services/urlString";
import { convertDate, compareDate } from "../../services/date";
import striptags from "striptags";
import { LOGO_URL } from "../../services/logoUrl";

const ArticleListArticle = ({ article }) => {
  if (!article) {
    return null;
  }
  const fromAgrarlex = article.site ? article.site.id === 12 : true;

  const showLabel =
    article.category && article.category.main_category ? true : false;
  const categorySlug = article.category ? article.category.slug : "";

  const isImportant = compareDate(
    new Date(article.important_until),
    new Date()
  );

  const href = fromAgrarlex
    ? "/artykuly/[category]/[article]"
    : "/artykuly-z-serwisow/[article]";
  const articleSlug = fromAgrarlex
    ? getRelativeArticlePath(article.get_external_url)
    : getRelativeArticleServicesPath(article.get_external_url);

  const croppedImage =
    article.crops && article.crops.find((el) => el.ratio === "320x180");
  return (
    <Link href={href} as={articleSlug} passHref={true}>
      <a>
        <S.Row isAdvertising={article.advertising}>
          {article.advertising && (
            <S.SpecialLabel>Publikacja specjalna</S.SpecialLabel>
          )}
          <S.ImgContainer>
            {showLabel && <S.Category>{article.category.name}</S.Category>}
            {!fromAgrarlex && (
              <S.SitesLabel>
                <S.Logo src={LOGO_URL[article.site.id]} />
              </S.SitesLabel>
            )}
            {article.image_cropped && (
              <S.Image
                src={replaceDomainToTap(
                  croppedImage?.image || article.image_cropped
                )}
              />
            )}
          </S.ImgContainer>
          <S.Column>
            {/* <S.Date>{convertDate(article.published_at)}</S.Date> */}
            {isImportant && <S.Important>WAŻNE</S.Important>}
            <S.Title>{article.title}</S.Title>
            <S.Lead>{striptags(article.lead)}</S.Lead>
            <S.ReadMore>czytaj więcej</S.ReadMore>
          </S.Column>
        </S.Row>
      </a>
    </Link>
  );
};

export default ArticleListArticle;
